import DashboardRoutes from './routes'
export default DashboardRoutes



// WEBPACK FOOTER //
// ./src/containers/dashboard/routes/index.js